import { useRef, useEffect } from 'react';

export const useIsFirstRender = () => {
  const isFirstRef = useRef(true);
  useEffect(() => {
    isFirstRef.current = false;
  }, []);
  return isFirstRef.current;
};
